module.exports = __webpack_public_path__ + "img/boho_rio_gift_flower.a58cd0d3.svg";